import { Ability, AbilityBuilder } from '@casl/ability';

const ability = new Ability([]);

const buildRulesFromPermissions = (permissions = [], userId = null) => {
  const { can, rules } = new AbilityBuilder(Ability);

  if (Array.isArray(permissions)) {
    permissions.forEach((permission) => {
      if (permission) {
        can('ADMINISTRATOR', permission);
      }
    });
  }

  if (userId) {
    can(`user_${userId}`);
  }

  return rules;
};

const updateAbilityRules = (permissions = [], userId = null) => {
  ability.update(buildRulesFromPermissions(permissions, userId));
};

const initializeAbilityFromStorage = () => {
  const storedPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
  updateAbilityRules(storedPermissions, storedUser?.id);
};

export { ability, initializeAbilityFromStorage, updateAbilityRules };



